import { API_ENDPOINTS } from "shared/constants";
import { buildSingleItem } from "shared/utils";
import {
  EnumKeys,
  IContact,
  IDataKeys,
  IDataState,
  IFile,
  IImageItem,
  IInfoBlockItem,
  IJSONAPIType,
  IPlace,
} from "shared/types";
import { keyBy } from "lodash-es";

export const infoBlockItemsSelectorHelper = ({
  type,
  paths,
  itemIds,
  data,
}: {
  type: IInfoBlockItem;
  paths?: string[];
  itemIds?: string[];
  data: { [key in EnumKeys]?: IJSONAPIType };
}) => {
  let pathsFromIds = paths || [];

  if (!pathsFromIds.length && itemIds) {
    pathsFromIds = itemIds.map(id => API_ENDPOINTS.INFO_BLOCK_ITEM(id, type));
  }

  return pathsFromIds
    .map(path => {
      const item = data[type]?.[path];

      switch (type) {
        default:
        case IInfoBlockItem.contact: {
          return item ? (buildSingleItem(item) as IContact) : ({} as IContact);
        }
        case IInfoBlockItem.place: {
          return item ? (buildSingleItem(item) as IPlace) : ({} as IPlace);
        }
        case IInfoBlockItem.file: {
          return item ? (buildSingleItem(item) as IFile) : ({} as IFile);
        }
        case IInfoBlockItem.image: {
          return item ? (buildSingleItem(item) as IImageItem) : ({} as IImageItem);
        }
      }
    })
    .filter(item => Object.keys(item).length);
};

export const infoBlockDetailMatcherHelper = (state: IDataState, block: unknown) => {
  const { attributes } = block as {
    attributes: {
      contacts: { data: IContact }[];
      places: { data: IPlace }[];
      files: { data: IFile }[];
      images: { data: IImageItem }[];
    };
  };

  const map: {
    name: "contacts" | "places" | "files" | "images";
    key: IDataKeys;
  }[] = [
    { name: "contacts", key: IDataKeys.contact },
    { name: "places", key: IDataKeys.place },
    { name: "files", key: IDataKeys.file },
    { name: "images", key: IDataKeys.image },
  ];

  const mergedState: { [key in IDataKeys]?: any } = {};
  attributes &&
    map.forEach(({ name, key }) => {
      const newItems = keyBy(
        attributes[name]?.map((item: { data: any }) => item.data),
        "id"
      );
      mergedState[key] = {
        ...state.data[key],
        ...newItems,
      };
    });

  return mergedState;
};
